import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../../../utils/cn";
import { CheckIcon } from "../../icons/CheckIcon";
import { ErrorIcon } from "../../icons/ErrorIcon";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  isValid?: boolean;
  hasError?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, isValid, hasError, rows = 5, ...props }, ref) => (
    <div className="relative w-full">
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "w-full rounded-sm border border-muted bg-surface px-3 py-2 pr-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
          className,
        )}
        aria-invalid={hasError || undefined}
        {...props}
      />
      {hasError ? (
        <ErrorIcon className="pointer-events-none absolute right-2 top-2 h-4 w-4 text-danger" />
      ) : isValid ? (
        <CheckIcon className="pointer-events-none absolute right-2 top-2 h-4 w-4 text-success" />
      ) : null}
    </div>
  ),
);
Textarea.displayName = "Textarea";

export default Textarea;
